export const cilClock1 = [
  '38 38',
  `
<path d="M21.212 7.46094H18.712V21.3759L27.7443 25.6687L28.8175 23.4107L21.212 19.796V7.46094Z" />
<path d="M20 1.25C9.64469 1.25 1.25 9.64469 1.25 20C1.25 30.3553 9.64469 38.75 20 38.75C30.3553 38.75 38.75 30.3553 38.75 20C38.75 9.64469 30.3553 1.25 20 1.25ZM20 36.25C11.0254 36.25 3.75 28.9746 3.75 20C3.75 11.0254 11.0254 3.75 20 3.75C28.9746 3.75 36.25 11.0254 36.25 20C36.25 28.9746 28.9746 36.25 20 36.25Z" />

`,
];
